<template>
  <div class="card">
    <card-header
      :title="$t('cms.campaign.CouponTitle')"
      :description="$t('cms.campaign.CouponText')"
      :infoConfig="$CONSTANTS.infoConfig.coupon"
      :hasCheckMark="true"
      :checked="numberOfCoupons > 0"
    >
      <template #icon>
        <icon coupon xlarge />
      </template>
    </card-header>

    <div class="flex">
      <div class="flex grow2 mr2">
        <router-link
          name="editcoupons"
          class="flex grow"
          :to="{ name: 'edit_coupons', params: { campaignId } }"
        >
          <button class="box grow flex secondary">
            <span class="flex grow bold align_center" name="editcoupontext">
              <icon :size="20"  class="mr1" plus/>
              {{ $t('cms.campaign.CouponAddButton') }}
            </span>
            <span class="flex ml2 pl3 pr1 py2 my-2 dashed bold medium">{{ numberOfCoupons }}</span>
          </button>
        </router-link>
      </div>

      <optional-link
        class="flex grow"
        name="previewcoupons"
        :disabled="!numberOfCoupons"
        :to="{ name: 'coupon_preview', params: { campaignId } }"
      >
        <button
          type="button"
          :disabled="!numberOfCoupons"
          class="box grow primary"
        >{{ $t('cms.campaign.CouponPreviewButton') }}</button>
      </optional-link>
    </div>
  </div>
</template>

<script>
import CardHeader from '@/components/global/CardHeader.vue';

export default {
  components: {
    CardHeader,
  },
  props: {
    numberOfCoupons: { type: Number },
    campaignId: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.dashed {
    border-left: dashed $color_border 1px;
  }
</style>
